import { render } from "./ProductLayout.vue?vue&type=template&id=0e50d236"
import script from "./ProductLayout.vue?vue&type=script&lang=js"
export * from "./ProductLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__